module.exports = __webpack_public_path__ + "img/ee8fa75.jpg";